<template>
  <a-layout class="ai-assistant__wrapper">
    <a-layout-header>
      <div class="ai-assistant__header__main">
        <div class="ai-assistant__header__title">{{ session && session.title }}</div>
        <a-space class="ai-assistant__header__info">
          <span>{{ session && (session.chats.length || session.msg_count) }}条对话</span>
          <span>{{ session && session.updated_at }}</span>
        </a-space>
      </div>
      <a-space class="ai-assistant__header__actions">
        <a-popover
          v-if="session && session.type === 'teamSession' && session.teamPrompts && session.teamPrompts.length && session.chats && session.chats.length > 0"
          title="选择主题">
          <a>选择其他主题</a>
          <template #content>
            <AiAssistantTeamPrompts :prompts="session && session.teamPrompts || []" @click="handlePromptClick" />
          </template>
        </a-popover>
        <a-popover
          v-if="prompts.length && session && session.type !== 'teamSession' && session.chats && session.chats.length > 0"
          title="选择主题">
          <a>选择其他主题</a>
          <template #content>
            <ai-assistant-prompts @click="handlePromptClick" />
          </template>
        </a-popover>
        <!-- 转为团队话题按钮 -->
        <a-tooltip v-if="session && session.type !== 'teamSession'" title="转为团队话题">
          <a class="ai-assistant__header__action" @click.prevent="convertToTeamTopic">
            <a-icon type="usergroup-add" />
          </a>
        </a-tooltip>
        <!-- 团队成员列表图标 -->
        <template v-if="session && session.type === 'teamSession'">
          <a class="ai-assistant__header__action">
            <a-popover placement="bottom" trigger="hover">
              <template #content>
                <div class="team-members-list">
                  <div v-if="session && session.partakeUsers && session.partakeUsers.length > 0">
                    <div v-for="(member, index) in session.partakeUsers" :key="index" class="team-member-item">
                      <a-avatar icon="user" :size="14" :style="{ backgroundColor: getAvatarColor(member.user_name) }">{{
                        getAvatarText(member.user_name) }}</a-avatar>
                      <span class="team-member-name">{{ member.user_name }}</span>
                    </div>
                  </div>
                  <div v-else class="team-member-empty">暂无团队成员</div>
                </div>
              </template>
              <a-icon type="team" />
            </a-popover>
          </a>
          <!-- 添加团队成员按钮 -->
          <a-tooltip title="添加团队成员">
            <a class="ai-assistant__header__action" @click.prevent="handleAddTeamMember">
              <a-icon type="user-add" />
            </a>
          </a-tooltip>
          <!-- 设置按钮 -->
          <a-dropdown>
            <a class="ai-assistant__header__action" @click.prevent>
              <a-icon type="setting" />
            </a>
            <a-menu slot="overlay">
              <a-menu-item key="edit" @click="handleEditTeamTopic">
                <a-icon type="edit" />编辑话题
              </a-menu-item>
              <a-menu-item key="delete" @click="handleDeleteTeamTopic">
                <a-icon type="delete" />删除话题
              </a-menu-item>
              <a-menu-item key="exit" @click="handleExitTeamTopic">
                <a-icon type="logout" />退出话题
              </a-menu-item>
            </a-menu>
          </a-dropdown>
        </template>
        <a-tooltip :title="fullscreen ? '还原' : '全屏'">
          <a class="ai-assistant__header__action" @click.prevent="triggerFullscreen">
            <a-icon :type="fullscreen ? 'fullscreen-exit' : 'fullscreen'" />
          </a>
        </a-tooltip>
      </a-space>
    </a-layout-header>
    <!-- 提示词列表 -->
    <a-layout-content ref="content">
      <AiAssistantTeamPrompts
        v-if="session && session.type === 'teamSession' && session.chats && session.chats.length === 0"
        :prompts="session && session.teamPrompts || []" @click="handlePromptClick" />
      <ai-assistant-prompts v-if="session && session.type === 'session' && session.chats && session.chats.length === 0"
        @click="handlePromptClick" />
      <div class="ai-assistant-chats">
        <div v-show="session && session.loading" class="ai-assistant-chat ai-assistant-chat--assistant">
          <div class="ai-assistant-chats__loading">
            <div class="ai-assistant-chats__loading-dot" />
            <div class="ai-assistant-chats__loading-dot" />
            <div class="ai-assistant-chats__loading-dot" />
          </div>
          <div class="ai-assistant-chat__content">思考中...</div>
        </div>
        <!-- <div v-show="inputValue.trim()" class="ai-assistant-chat ai-assistant-chat--user">
          <div class="ai-assistant-chat__content">{{ inputValue }}</div>
        </div> -->
        <!-- 问答列表 -->
        <div v-for="(message, index) in (session && session.chats || [])" :key="index" :class="{
          'ai-assistant-chat': true,
          'ai-assistant-chat--user': message.source === 1,
          'ai-assistant-chat--assistant': message.source === 2
        }">
          <a-divider v-if="message.source === 3">清除上下文</a-divider>
          <div v-if="message.source !== 3" class="ai-assistant-chat__datetime">{{ message.created_at }}<span v-if="message.source === 1" style="margin-left:4px">{{ message.user_name }}</span></div>
          <div v-if="message.source !== 3" class="ai-assistant-chat__content">
            <div v-if="message.think" class="ai-assistant-chat__think" v-html="message.think" />
            <div v-if="message.source === 1" class="ai-assistant-chat__html" v-html="message.content" />
            <div v-if="message.source === 2" class="ai-assistant-chat__markdown" v-html="message.markdown" />
          </div>
          <div v-if="message.source === 2" class="ai-assistant-chat__tools">
            <a-space>
              <a-tooltip title="复制">
                <a @click="copyText(message.content)">
                  <a-icon type="copy" />
                </a>
              </a-tooltip>
              <a-tooltip title="引用">
                <a @click="quoteMessage(message)">
                  <a-icon type="message" />
                </a>
              </a-tooltip>
              <a-tooltip title="重新生成">
                <a @click="reSend(message)">
                  <a-icon type="redo" />
                </a>
              </a-tooltip>
            </a-space>
          </div>
        </div>
      </div>
    </a-layout-content>
    <a-layout-footer>
      <a-space style="margin-bottom: 10px;">
        <a-select v-model="modelId" :dropdown-match-select-width="false" style="width: 135px">
          <a-select-option v-for="item in models" :key="item.model_id" :value="item.model_id">
            {{ item.model_name }}
          </a-select-option>
        </a-select>
        <!-- <a-button :type="isDeepSeek ? 'primary' : 'default'">
          <a-icon type="control" />深度思考
        </a-button> -->
        <!-- <a-button :type="isNetwork ? 'primary' : 'default'" @click="triggerNetwork"><a-icon type="global" />联网查询</a-button> -->
        <a-button type="default" @click="partition">清除上下文</a-button>
      </a-space>
      <div class="ai-assistant__textarea" ref="textarea">
        <div v-if="quotedMessages.length > 0" class="ai-assistant__quote">
          <div v-for="(quote, index) in quotedMessages" :key="index" class="ai-assistant__quote-item">
            <div class="ai-assistant__quote-content" v-html="processQuoteContent(quote.markdown || quote.content)"></div>
            <a-button type="link" class="ai-assistant__quote-close" @click="removeQuote(index)">
              <a-icon type="close" />
            </a-button>
          </div>
          <div class="ai-assistant__quote-actions">
            <a-button type="link" size="small" @click="() => quotedMessages = []">清除全部引用</a-button>
          </div>
        </div>
        <a-input type="textarea" v-model="inputValue" :autosize="{ minRows: 6, maxRows: 8 }"
          :disabled="session && (session.streaming || session.loading)"
          placeholder="这里是AI智能问答，您可以进行和AI自由对话或获取建议。如需查询ERP数据，请前往“智能体”" @keydown="handleSendMessage" />
        <a-button v-if="session && !session.streaming" class="ai-assistant__textarea__button" type="primary"
          :disabled="session.loading" @click="sendMessage">
          发送
        </a-button>
        <a-button v-else class="ai-assistant__textarea__button" type="danger" @click="stopMessage">
          <i style="margin-right: 4px;display: inline-block;width: 11px;height: 11px;background-color: #fff;" />停止
        </a-button>
      </div>
      <div style="margin-top: 5px;margin-bottom: -5px;display: flex;align-items: center;">
        <span style="color: #0B1019;font-size: 12px;">剩余搜索量{{ quota && quota.daily_use_total || '0' }}/{{ quota &&
          quota.daily_quota || '10' }}（限时免费，每日免费搜索量{{ quota && quota.daily_quota || '10' }}条）</span>
        <span style="color: #9199A7;font-size: 10px;">所有内容均由AI生成,仅供参考</span>
      </div>
    </a-layout-footer>
    <team-topic-modal ref="teamTopicModal" />
  </a-layout>
</template>

<script>
import { mapGetters } from 'vuex'
import AiAssistantPrompts from './AiAssistantPrompts'
import TeamTopicModal from './TeamTopicModal'
import AiAssistantTeamPrompts from './AiAssistantTeamPrompts'

export default {
  name: 'AiAssistantChats',
  components: {
    AiAssistantPrompts,
    TeamTopicModal,
    AiAssistantTeamPrompts
  },
  data() {
    return {
      loading: false,
      modelId: 1,
      isDeepSeek: true,
      isNetwork: false,
      inputValue: '',
      isStreaming: false,
      abortController: null,
      quotedMessages: [],
      maxQuoteLines: 2 // 最大显示引用行数
    }
  },
  computed: {
    ...mapGetters('aiAssistant', ['models', 'session', 'session_id', 'chats', 'quota', 'fullscreen', 'prompts'])
  },
  methods: {
    getAvatarColor(name) {
      // 根据名字生成固定颜色
      const colors = ['#1890ff', '#52c41a', '#faad14', '#f5222d', '#722ed1', '#13c2c2', '#eb2f96']
      const charCode = name ? name.charCodeAt(0) : 0
      return colors[charCode % colors.length]
    },
    removeQuote(index) {
      this.quotedMessages.splice(index, 1)
    },
    getAvatarText(name) {
      // 获取名字的第一个字符作为头像文字
      return name ? name.charAt(0).toUpperCase() : '?'
    },
    // 添加团队成员
    handleAddTeamMember() {
      this.$refs.teamTopicModal.open(this.session, true)
    },
    triggerDeepSeek() {
      this.isDeepSeek = !this.isDeepSeek
    },
    triggerNetwork() {
      this.isNetwork = !this.isNetwork
    },
    handleSendMessage(e) {
      // 判断是否shift+enter
      if (e.shiftKey && e.keyCode === 13) {
      } else if (e.keyCode === 13) {
        e.preventDefault()
        this.sendMessage()
      }
    },
    // 发送消息
    sendMessage() {
      if (this.quota && this.quota.daily_use_total >= this.quota.daily_quota) {
        this.$message.warning('今日额度已达上限')
        return
      }

      if (!this.inputValue?.trim?.() && !this.loading) return

      console.log('发送消息：', this.inputValue)

      const code = this.models.find((item) => item.model_id === this.modelId)?.model_code || 'deepseek-r1'
      // source: 1 用户 2 助手 3 清除上下文
      let history = this.chats.map((item) => {
        if (item.source === 3) return undefined
        return item.source === 1
          ? { '问': item.content }
          : { '答': item.content }
      })

      // 获取最后一次清除上下文之后的历史对话
      if (history.some((item) => item === undefined)) {
        history = history.slice(0, history.lastIndexOf(undefined))
      }

      if (this.quotedMessages.length > 0) {
        history = this.quotedMessages.map((item) => {
        if (item.source === 3) return undefined
        return item.source === 1
          ? { '问': item.content }
          : { '答': item.content }
        })
      }

      this.loading = true
      this.$store.dispatch('aiAssistant/sendMessage', {
        method: 'question',
        data: {
          session_id: this.session_id,
          message: this.inputValue.trim(),
          model_code: code,
          his_messages: history.reverse()
        }
      }).then(() => {
        this.inputValue = ''
        this.loading = false
        this.quotedMessages = []
        this.scrollBottom()
      })
    },
    // 停止生成
    stopMessage() {
      console.log(394399439)
      this.$store.dispatch('aiAssistant/stopMessage')
    },
    // 开关全屏功能
    triggerFullscreen() {
      this.$store.dispatch('aiAssistant/triggerFullscreen')
    },
    // 点击提示词
    handlePromptClick(item) {
      this.inputValue = item.content
    },
    scrollBottom() {
      this.$nextTick(() => {
        const content = this.$refs.content && this.$refs.content.$el
        if (content) {
          content.scrollTop = content.scrollHeight
        }
      })
    },
    quoteMessage (message) {
      // 检查是否已经引用了该消息
      const isDuplicate = this.quotedMessages.some((msg) =>
        msg.message_id === message.message_id ||
        (msg.content === message.content && msg.source === message.source)
      )

      if (!isDuplicate) {
        this.quotedMessages.push(message)
      }
      this.focusTextarea()
    },
    // 处理引用内容，超过指定行数显示省略号
    processQuoteContent(html) {
      if (!html) return ''

      // 创建临时DOM元素来解析HTML
      const tempDiv = document.createElement('div')
      tempDiv.innerHTML = html

      // 获取纯文本内容
      const textContent = tempDiv.textContent || tempDiv.innerText

      // 按换行符分割文本内容
      const lines = textContent.split('\n').filter(line => line.trim())

      if (lines.length <= this.maxQuoteLines) {
        // 如果行数不超过限制，直接返回原始HTML
        return html
      } else {
        // 如果行数超过限制，截取前几行并添加省略号
        const visibleLines = lines.slice(0, this.maxQuoteLines)
        const visibleText = visibleLines.join('\n')

        // 创建新的临时元素来保持HTML格式
        const newTempDiv = document.createElement('div')
        newTempDiv.innerHTML = html

        // 创建包含省略号的元素
        const ellipsisSpan = document.createElement('span')
        ellipsisSpan.className = 'quote-ellipsis'
        ellipsisSpan.textContent = '...'

        // 将内容替换为截断的内容加省略号
        newTempDiv.textContent = visibleText
        newTempDiv.appendChild(ellipsisSpan)

        return newTempDiv.innerHTML
      }
    },
    copyText(html) {
      // 创建临时DOM元素来解析HTML
      const tempDiv = document.createElement('div')
      tempDiv.innerHTML = html

      // 移除所有<think>标签
      const thinkElements = tempDiv.getElementsByTagName('think')
      while (thinkElements.length > 0) {
        thinkElements[0].parentNode.removeChild(thinkElements[0])
      }

      // 获取处理后的文本内容
      const textContent = tempDiv.textContent || tempDiv.innerText

      // 使用Clipboard API复制文本
      navigator.clipboard.writeText(textContent.trim())
        .then(() => {
          this.$message.success('复制成功')
        })
        .catch(() => {
          this.$message.error('复制失败')
        })
    },
    getSessionDetail() {
      if (!this.session_id) return
      this.$store.dispatch('aiAssistant/send', {
        method: 'getSessionDetail',
        data: { session_id: this.session_id }
      })

      setTimeout(() => {
        this.scrollBottom()
      }, 500)
    },
    handleEditTeamTopic() {
      this.$refs.teamTopicModal.open(this.session)
    },
    // 删除团队话题
    handleDeleteTeamTopic() {
      this.$confirm({
        title: '确认删除',
        content: `确定要删除团队话题"${this.session.title}"吗？`,
        okText: '确认',
        cancelText: '取消',
        onOk: () => {
          this.$store.dispatch('aiAssistant/send', {
            method: 'clearSession',
            data: {
              session_id: this.session.session_id
            }
          })
        }
      })
    },
    // 退出团队话题
    handleExitTeamTopic() {
      this.$confirm({
        title: '确认退出',
        content: `确定要退出团队话题"${this.session.title}"吗？`,
        okText: '确认',
        cancelText: '取消',
        onOk: () => {
          this.$store.dispatch('aiAssistant/send', {
            method: 'exitSession',
            data: {
              session_id: this.session.session_id
            }
          })
        }
      })
    },
    reSend(message) {
      if (this.quota && this.quota.daily_use_total >= this.quota.daily_quota) {
        this.$message.warning('今日额度已达上限')
        return
      }

      if (this.loading || this.session.streaming || this.session.loading) {
        this.$message.warning('请等待上一条消息生成完成')
        return
      }

      const index = this.chats.findIndex((item) => item.message_id === message.message_id)

      if (index !== -1) {
        const code = this.models.find((item) => item.model_id === this.modelId)?.model_code || 'deepseek-r1'
        // source: 1 用户 2 助手 3 清除上下文
        let history = this.chats.map((item) => {
          if (item.source === 3) return undefined
          return item.source === 2
            ? { '问': item.content }
            : { '答': item.content }
        })

        // 获取最后一次清除上下文之后的历史对话
        if (history.some((item) => item === undefined)) {
          history = history.slice(0, history.lastIndexOf(undefined))
        }

        this.loading = true
        this.$store.dispatch('aiAssistant/sendMessage', {
          method: 'question',
          data: {
            session_id: this.session_id,
            message: this.chats[index + 1].content,
            model_code: code,
            his_messages: history.reverse()
          }
        }).then(() => {
          this.loading = false
          this.scrollBottom()
        })
      }
    },
    partition() {
      if (this.loading || this.session.streaming || this.session.loading) {
        this.$message.warning('请等待上一条消息生成完成')
        return
      }

      this.$store.dispatch('aiAssistant/clearSessionPartition', this.session_id)
    },
    focusTextarea() {
      const textarea = this.$refs.textarea
      if (textarea) {
        // 聚焦到子元素textarea
        const textareaChild = textarea.querySelector('textarea')
        if (textareaChild) {
          setTimeout(() => {
            // 聚焦到文本框
            textareaChild.focus()
            // 选中所有文本
            textareaChild.select()
            // 模拟点击事件
            textareaChild.click()
          }, 200)
        }
      }
    },
    init() {
      if (!this.session_id) return
      this.getSessionDetail()
      this.focusTextarea()
    },
    // 将个人话题转为团队话题
    convertToTeamTopic() {
      if (!this.session) return
      this.$refs.teamTopicModal.open({
        title: this.session.title,
        sourceSessionId: this.session.session_id
      })
    }
  },
  watch: {
    session_id: {
      handler: 'init',
      immediate: true
    },
    chats: {
      handler: 'scrollBottom',
      deep: true
    },
    session: {
      handler(newVal) {
        if (newVal && newVal.streaming) {
          this.focusTextarea()
        }
      }
    }
  },
  mounted() {
    this.getSessionDetail()
  }
}
</script>

<style lang="less" scoped>
@import "./chats.less";
.team-members-list {
  max-height: 200px;
  overflow-y: auto;
  padding-right: 5px;
}

.team-member-item {
  display: flex;
  align-items: center;
  padding: 5px;
  border-bottom: 1px solid #f0f0f0;
}

.team-member-item:last-child {
  border-bottom: none;
}

.team-member-name {
  margin-left: 10px;
}

.team-member-empty {
  text-align: center;
  padding: 20px;
  color: #ccc;
}
.ai-assistant__quote {
  background-color: #f0f0f0;
  padding: 10px;
  border-bottom: 1px solid #d9d9d9;
  max-height: 200px;
  overflow-y: auto;
}

.ai-assistant__quote-item {
  position: relative;
  padding: 5px;
  margin-bottom: 5px;
  border-bottom: 1px dashed #d9d9d9;
}

.ai-assistant__quote-content {
  font-size: 12px;
  color: #666;
  padding-right: 20px;
  max-height: 60px;
  overflow: hidden;
  white-space: pre-line;
  line-height: 1.5;
}

.quote-ellipsis {
  display: inline-block;
  color: #999;
  font-weight: bold;
  margin-left: 4px;
}

.ai-assistant__quote-close {
  position: absolute;
  top: 0;
  right: 0;
  padding: 0;
}

.ai-assistant__quote-actions {
  text-align: right;
  margin-top: 5px;
}
</style>
